<script setup lang="ts">
  import { ExternalRoute } from "@/constants/externalRoute"
  import { Route } from "@/constants/route.ts"
  import Button from "@/components/ui/button/Button.vue"
  import Card from "@/components/ui/card/Card.vue"
  import CardContent from "@/components/ui/card/CardContent.vue"
  import CardFooter from "@/components/ui/card/CardFooter.vue"
  import CardHeader from "@/components/ui/card/CardHeader.vue"
  import CardTitle from "@/components/ui/card/CardTitle.vue"
  import { Link } from "@/components/ui/link"

  const parkingPage = `${Route.evChargerQuote}/${Route.evChargerQuoteParking}`
</script>

<template>
  <div class="m-auto max-w-[697px]">
    <Card class="mb-6">
      <CardHeader>
        <CardTitle> We're sorry </CardTitle>
      </CardHeader>
      <CardContent>
        <p class="mb-4 sm:mb-6">
          We’re unable to install an EV charger for you at this moment in time,
          as off-street parking is required. We understand this may be
          disappointing, but currently, we can only install an EV charger if you
          have off-street parking, such as a driveway or garage.
        </p>
        <p>
          If you do have off-street parking and answered the last question
          incorrectly, you can return to the previous page by using the button
          below.
        </p>
      </CardContent>
      <CardFooter>
        <Button
          class="mt-4"
          variant="outline"
          as-child
          data-testid="back-to-parking-page"
        >
          <RouterLink :to="parkingPage"> Back </RouterLink>
        </Button>
      </CardFooter>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle> Want to talk to us? </CardTitle>
      </CardHeader>
      <CardContent>
        If you have a question about what you need to have a charger installed,
        email us at
        <Link class="link text-primary-600" to="mailto:ev@so.energy"
          >ev@so.energy</Link
        >, or you can call our friendly team on
        <Link class="link text-primary-600" to="tel:020 4625 1900"
          >020 4625 1900</Link
        >, available weekdays between 9am-5pm.
      </CardContent>
      <CardFooter>
        <Button
          :href="ExternalRoute.contactUs"
          as="a"
          icon="Message"
          icon-position="left"
          data-testid="ev-charger-no-parking-contact-button"
        >
          Send us a message
        </Button>
      </CardFooter>
    </Card>
  </div>
</template>
